import { SvgIcon } from '@mui/material';

const Icon = (props: any) => (
  <SvgIcon {...props} viewBox="0.652 0.759 9.825 13.46">
    <path
      paintOrder="stroke fill markers"
      fillRule="evenodd"
      d="M5.565.759l-.557.557c-.18.18-4.356 4.405-4.356 7.99a4.927 4.927 0 0 0 4.913 4.913 4.927 4.927 0 0 0 4.912-4.912c0-3.57-4.176-7.811-4.356-7.991L5.565.759zM3.108 8.488a.81.81 0 0 1 .819.819c0 .9.737 1.637 1.638 1.637a.81.81 0 0 1 .818.819.81.81 0 0 1-.818.819A3.285 3.285 0 0 1 2.29 9.307a.81.81 0 0 1 .818-.82z"
    />
  </SvgIcon>
);

export default Icon;
